// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width:950px){
    .vertical-cylinder-tank-widget-container{
        position: relative;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
    }
    .vertical-cylinder-tank-widget-tool-tip{
        visibility: hidden;
        opacity: 0;
        position: absolute;
        padding: 8px 12px;
        border-radius: 4px;
        box-sizing: border-box;
        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.15);
        background-color: rgba(255, 255, 255, 0.884);
        transition: opacity 2s ease, visibility 0s linear 2s;
    }
    .vertical-cylinder-tank-widget-container:hover .vertical-cylinder-tank-widget-tool-tip{
        visibility: visible;
        opacity: 1;
        transition: opacity 2s ease;
    }
    .vertical-cylinder-tank-widget-tool-tip p{
        display: flex;
        justify-content: space-between;
        margin: 5px 0px;
        font-size: 13px;
        color: rgb(110, 110, 110);
    }
    .vertical-cylinder-tank-widget-tool-tip span{
        margin-left: 15px;
        color: rgb(20, 20, 20);
    }
    .vertical-cylinder-tank-widget-header{
        width: 100%;
        padding: 16px 20px;
        box-sizing: border-box;
    }
    .vertical-cylinder-tank-widget-header p{
        margin: 0px;
    }
    .vertical-cylinder-tank-widget-body{
        width: 100%;
        display: flex;
        flex-grow: 1;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
    }
    .vertical-cylinder-tank-widget-tank-container{
        width: 70%;
        height: 80%;
    }
    .vertical-cylinder-tank-widget-tank-container svg{
        width: 100%;
        height: 100%;
        display: block;
        flex-shrink: 0;
    }
    .vertical-cylinder-values-display-container{
        position: absolute;
        top: 65%;
        transform: translateY(-50%);
        padding: 8px 10px;
        border-radius: 5px;
        background-color: white;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);
    }
    .vertical-cylinder-absolute-values-display-container{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .vertical-cylinder-absolute-values-display-container .values-container{
        margin-left: 10px;
    }
    .vertical-cylinder-absolute-values-display-container .values-container p{
        font-size: 15px;
        font-weight: 500;
        margin: 3px 0px;
        text-align: center;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .vertical-cylinder-absolute-values-display-container .values-container .numerator{
        border-bottom: 1px solid black;
    }
    .vertical-cylinder-absolute-values-display-container .units-container p{
        font-size: 15px;
        font-weight: 500;
        margin: 0px;
        margin-left: 10px;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .vertical-cylinder-percentage-values-display-container p{
        margin: 14px 15px;
        font-weight: 500;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
}
@media screen and (max-width:949px){
    .vertical-cylinder-tank-widget-container{
        position: relative;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
    }
    .vertical-cylinder-tank-widget-tool-tip{
        visibility: hidden;
        opacity: 0;
        position: absolute;
        padding: 8px 12px;
        border-radius: 4px;
        box-sizing: border-box;
        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.15);
        background-color: rgba(255, 255, 255, 0.884);
        transition: opacity 3s ease, visibility 0s linear 4s;
    }
    .vertical-cylinder-tank-widget-container:hover .vertical-cylinder-tank-widget-tool-tip{
        visibility: visible;
        opacity: 1;
        transition: opacity 3s ease;
    }
    .vertical-cylinder-tank-widget-tool-tip p{
        display: flex;
        justify-content: space-between;
        margin: 5px 0px;
        font-size: 13px;
        color: rgb(110, 110, 110);
    }
    .vertical-cylinder-tank-widget-tool-tip span{
        margin-left: 15px;
        color: rgb(20, 20, 20);
    }
    .vertical-cylinder-tank-widget-header{
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 0px 20px;
        box-sizing: border-box;
    }
    .vertical-cylinder-tank-widget-body{
        width: 100%;
        display: flex;
        flex-grow: 1;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
    }
    .vertical-cylinder-tank-widget-tank-container{
        width: 65%;
        height: 72%;
    }
    .vertical-cylinder-tank-widget-tank-container svg{
        width: 100%;
        height: 100%;
        display: block;
        flex-shrink: 0;
    }
    .vertical-cylinder-values-display-container{
        position: absolute;
        top: 65%;
        transform: translateY(-50%);
        padding: 15px;
        border-radius: 5px;
        background-color: white;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);
    }
    .vertical-cylinder-absolute-values-display-container{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .vertical-cylinder-absolute-values-display-container .values-container{
        margin-left: 10px;
    }
    .vertical-cylinder-absolute-values-display-container .values-container p{
        margin: 2px 0px;
        text-align: center;
    }
    .vertical-cylinder-absolute-values-display-container .values-container .numerator{
        border-bottom: 1px solid black;
    }
    .vertical-cylinder-absolute-values-display-container .units-container p{
        margin: 0px;
        margin-left: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Widgets/LiquidLevel/VerticalCylinderTankWidget.css"],"names":[],"mappings":"AAAA;IACI;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,2BAA2B;QAC3B,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;QACI,kBAAkB;QAClB,UAAU;QACV,kBAAkB;QAClB,iBAAiB;QACjB,kBAAkB;QAClB,sBAAsB;QACtB,2CAA2C;QAC3C,4CAA4C;QAC5C,oDAAoD;IACxD;IACA;QACI,mBAAmB;QACnB,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,eAAe;QACf,eAAe;QACf,yBAAyB;IAC7B;IACA;QACI,iBAAiB;QACjB,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,aAAa;QACb,YAAY;QACZ,mBAAmB;QACnB,uBAAuB;QACvB,sBAAsB;IAC1B;IACA;QACI,UAAU;QACV,WAAW;IACf;IACA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;QACd,cAAc;IAClB;IACA;QACI,kBAAkB;QAClB,QAAQ;QACR,2BAA2B;QAC3B,iBAAiB;QACjB,kBAAkB;QAClB,uBAAuB;QACvB,0CAA0C;IAC9C;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,kBAAkB;QAClB,4DAA4D;IAChE;IACA;QACI,8BAA8B;IAClC;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,WAAW;QACX,iBAAiB;QACjB,4DAA4D;IAChE;IACA;QACI,iBAAiB;QACjB,gBAAgB;QAChB,4DAA4D;IAChE;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,2BAA2B;QAC3B,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;QACI,kBAAkB;QAClB,UAAU;QACV,kBAAkB;QAClB,iBAAiB;QACjB,kBAAkB;QAClB,sBAAsB;QACtB,2CAA2C;QAC3C,4CAA4C;QAC5C,oDAAoD;IACxD;IACA;QACI,mBAAmB;QACnB,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,eAAe;QACf,eAAe;QACf,yBAAyB;IAC7B;IACA;QACI,iBAAiB;QACjB,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,aAAa;QACb,8BAA8B;QAC9B,iBAAiB;QACjB,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,aAAa;QACb,YAAY;QACZ,mBAAmB;QACnB,uBAAuB;QACvB,sBAAsB;IAC1B;IACA;QACI,UAAU;QACV,WAAW;IACf;IACA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;QACd,cAAc;IAClB;IACA;QACI,kBAAkB;QAClB,QAAQ;QACR,2BAA2B;QAC3B,aAAa;QACb,kBAAkB;QAClB,uBAAuB;QACvB,0CAA0C;IAC9C;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,8BAA8B;IAClC;IACA;QACI,WAAW;QACX,iBAAiB;IACrB;AACJ","sourcesContent":["@media screen and (min-width:950px){\r\n    .vertical-cylinder-tank-widget-container{\r\n        position: relative;\r\n        height: 100%;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: flex-start;\r\n        align-items: center;\r\n        box-sizing: border-box;\r\n    }\r\n    .vertical-cylinder-tank-widget-tool-tip{\r\n        visibility: hidden;\r\n        opacity: 0;\r\n        position: absolute;\r\n        padding: 8px 12px;\r\n        border-radius: 4px;\r\n        box-sizing: border-box;\r\n        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.15);\r\n        background-color: rgba(255, 255, 255, 0.884);\r\n        transition: opacity 2s ease, visibility 0s linear 2s;\r\n    }\r\n    .vertical-cylinder-tank-widget-container:hover .vertical-cylinder-tank-widget-tool-tip{\r\n        visibility: visible;\r\n        opacity: 1;\r\n        transition: opacity 2s ease;\r\n    }\r\n    .vertical-cylinder-tank-widget-tool-tip p{\r\n        display: flex;\r\n        justify-content: space-between;\r\n        margin: 5px 0px;\r\n        font-size: 13px;\r\n        color: rgb(110, 110, 110);\r\n    }\r\n    .vertical-cylinder-tank-widget-tool-tip span{\r\n        margin-left: 15px;\r\n        color: rgb(20, 20, 20);\r\n    }\r\n    .vertical-cylinder-tank-widget-header{\r\n        width: 100%;\r\n        padding: 16px 20px;\r\n        box-sizing: border-box;\r\n    }\r\n    .vertical-cylinder-tank-widget-header p{\r\n        margin: 0px;\r\n    }\r\n    .vertical-cylinder-tank-widget-body{\r\n        width: 100%;\r\n        display: flex;\r\n        flex-grow: 1;\r\n        align-items: center;\r\n        justify-content: center;\r\n        box-sizing: border-box;\r\n    }\r\n    .vertical-cylinder-tank-widget-tank-container{\r\n        width: 70%;\r\n        height: 80%;\r\n    }\r\n    .vertical-cylinder-tank-widget-tank-container svg{\r\n        width: 100%;\r\n        height: 100%;\r\n        display: block;\r\n        flex-shrink: 0;\r\n    }\r\n    .vertical-cylinder-values-display-container{\r\n        position: absolute;\r\n        top: 65%;\r\n        transform: translateY(-50%);\r\n        padding: 8px 10px;\r\n        border-radius: 5px;\r\n        background-color: white;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);\r\n    }\r\n    .vertical-cylinder-absolute-values-display-container{\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n    .vertical-cylinder-absolute-values-display-container .values-container{\r\n        margin-left: 10px;\r\n    }\r\n    .vertical-cylinder-absolute-values-display-container .values-container p{\r\n        font-size: 15px;\r\n        font-weight: 500;\r\n        margin: 3px 0px;\r\n        text-align: center;\r\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    }\r\n    .vertical-cylinder-absolute-values-display-container .values-container .numerator{\r\n        border-bottom: 1px solid black;\r\n    }\r\n    .vertical-cylinder-absolute-values-display-container .units-container p{\r\n        font-size: 15px;\r\n        font-weight: 500;\r\n        margin: 0px;\r\n        margin-left: 10px;\r\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    }\r\n    .vertical-cylinder-percentage-values-display-container p{\r\n        margin: 14px 15px;\r\n        font-weight: 500;\r\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    }\r\n}\r\n@media screen and (max-width:949px){\r\n    .vertical-cylinder-tank-widget-container{\r\n        position: relative;\r\n        height: 100%;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: flex-start;\r\n        align-items: center;\r\n        box-sizing: border-box;\r\n    }\r\n    .vertical-cylinder-tank-widget-tool-tip{\r\n        visibility: hidden;\r\n        opacity: 0;\r\n        position: absolute;\r\n        padding: 8px 12px;\r\n        border-radius: 4px;\r\n        box-sizing: border-box;\r\n        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.15);\r\n        background-color: rgba(255, 255, 255, 0.884);\r\n        transition: opacity 3s ease, visibility 0s linear 4s;\r\n    }\r\n    .vertical-cylinder-tank-widget-container:hover .vertical-cylinder-tank-widget-tool-tip{\r\n        visibility: visible;\r\n        opacity: 1;\r\n        transition: opacity 3s ease;\r\n    }\r\n    .vertical-cylinder-tank-widget-tool-tip p{\r\n        display: flex;\r\n        justify-content: space-between;\r\n        margin: 5px 0px;\r\n        font-size: 13px;\r\n        color: rgb(110, 110, 110);\r\n    }\r\n    .vertical-cylinder-tank-widget-tool-tip span{\r\n        margin-left: 15px;\r\n        color: rgb(20, 20, 20);\r\n    }\r\n    .vertical-cylinder-tank-widget-header{\r\n        width: 100%;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        padding: 0px 20px;\r\n        box-sizing: border-box;\r\n    }\r\n    .vertical-cylinder-tank-widget-body{\r\n        width: 100%;\r\n        display: flex;\r\n        flex-grow: 1;\r\n        align-items: center;\r\n        justify-content: center;\r\n        box-sizing: border-box;\r\n    }\r\n    .vertical-cylinder-tank-widget-tank-container{\r\n        width: 65%;\r\n        height: 72%;\r\n    }\r\n    .vertical-cylinder-tank-widget-tank-container svg{\r\n        width: 100%;\r\n        height: 100%;\r\n        display: block;\r\n        flex-shrink: 0;\r\n    }\r\n    .vertical-cylinder-values-display-container{\r\n        position: absolute;\r\n        top: 65%;\r\n        transform: translateY(-50%);\r\n        padding: 15px;\r\n        border-radius: 5px;\r\n        background-color: white;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);\r\n    }\r\n    .vertical-cylinder-absolute-values-display-container{\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n    .vertical-cylinder-absolute-values-display-container .values-container{\r\n        margin-left: 10px;\r\n    }\r\n    .vertical-cylinder-absolute-values-display-container .values-container p{\r\n        margin: 2px 0px;\r\n        text-align: center;\r\n    }\r\n    .vertical-cylinder-absolute-values-display-container .values-container .numerator{\r\n        border-bottom: 1px solid black;\r\n    }\r\n    .vertical-cylinder-absolute-values-display-container .units-container p{\r\n        margin: 0px;\r\n        margin-left: 10px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
